import { type ButtonHTMLAttributes } from 'react'

type PrimaryButtonProps = ButtonHTMLAttributes<HTMLButtonElement>

export function PrimaryButton({
  className = '',
  ...props
}: PrimaryButtonProps) {
  return (
    <button
      {...props}
      className={`inline-flex min-h-11 w-full cursor-pointer items-center justify-center rounded-xl bg-accent px-6 text-[14px] font-medium text-white transition-all hover:-translate-y-px hover:bg-[#15296b] disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:translate-y-0 disabled:hover:bg-accent sm:min-h-0 sm:w-auto sm:py-2.5 ${className}`}
    />
  )
}
